


export const validEmailRegex = RegExp(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/);
    
// var varObj = { test: 1 } => getVariableName(test) will return: "test"
export const getVariableName = (varObj: Object) : string => {
    return Object.keys(varObj)[0];
}




export function hexToRgb(hex: string) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    
    var res = result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;

    return res;
}

export function rgbToHex(r: number, g: number, b: number) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

// for error validation label
export const getUnusableCharacterInsideUrl = () => {
    return '/\\?!@#$%^&*()'
}

export const isUsableInsideUrl = (str: string) => {

    // IMPORTANT:
    // without using \\\\ the test wont work properly for
    // testing backslashes

    let invalidCharacters = '/\\\\?!@#$%^&*()'

    let regex: RegExp = new RegExp(`[${invalidCharacters}]`)

    if (!regex.test(str))
    {
        // No special chars
        return true;
    }

    return false;
}